import { useState, useEffect } from "react";
import _ from "lodash";
import { getPropertyCategoriesWithTypes } from "../../../services/commonServices";
import {
  BUY,
  PROPERTY_TYPE_TO_CATEGORY,
} from "../../../constants/common";
import { convertToNumber } from "../../../helpers/validations";

const InventoryPropertyTypes = (props) => {
  const {
    handleContinueButtonState,
    handleFormValues,
    propertyType,
    propertyCategory,
    adType,
    clearPreviousStates,
    isEdit = false,
  } = props;

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    getPropertyCategoriesWithTypes("buy")
      .then((response) => {
        if (response.errorCode === 0 && _.get(response, "result", null)) {
          setCategories(_.get(response, "result", null));
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      if (propertyCategory) {
        setSelectedCategory(propertyCategory);
      } else if (propertyType) {
        const inferredCategory = PROPERTY_TYPE_TO_CATEGORY[propertyType];
        if (inferredCategory) {
          setSelectedCategory(inferredCategory);
          // Pre-RESO drafts have no stored category; persist the inferred one.
          handleFormValues({
            propertyCategory: inferredCategory,
            propertyCategoryTxt: _.get(
              categories.find((c) => c.CategoryId === inferredCategory),
              "CategoryText",
              ""
            ),
          });
        }
      }
    }
  }, [categories, propertyCategory, propertyType]);

  useEffect(() => {
    if (propertyType) {
      handleContinueButtonState();
    } else {
      handleContinueButtonState(true);
    }
  }, []);

  const handleCategorySelect = (categoryId, categoryText) => {
    const isSameCategory = convertToNumber(categoryId) === convertToNumber(selectedCategory);
    if (isSameCategory) return;

    setSelectedCategory(categoryId);
    handleContinueButtonState(true);
    clearPreviousStates();
    handleFormValues({
      propertyCategory: categoryId,
      propertyCategoryTxt: categoryText,
      prprtyType: "",
      prptyTypeTxt: "",
    });
  };

  const handleTypeSelect = (typeId, typeText) => {
    const isSameType = convertToNumber(typeId) === convertToNumber(propertyType);
    if (isSameType) return;

    handleContinueButtonState();
    clearPreviousStates();
    handleFormValues({
      prprtyType: typeId,
      prptyTypeTxt: typeText,
    });
  };

  const selectedCategoryData = categories.find(
    (c) => c.CategoryId === selectedCategory
  );

  const loadPropertyTypes = () => {
    if (!selectedCategoryData) return null;
    return selectedCategoryData.types.map((pt) => {
      const typeId = pt.PropertyTypeId;
      const typeText = pt.PropertyTypeText;
      const Desc = pt.Description || "";
      const isChecked = convertToNumber(propertyType) === convertToNumber(typeId);
      return (
        <div
          key={typeId}
          className={
            !isEdit
              ? "col-sm-12 col-lg-12 col-xl-12 col-xxl-6"
              : "col-sm-12 col-lg-12 col-xl-12 col-xxl-12"
          }
        >
          <label className="radio-wrap mb-3">
            <input
              type="radio"
              name="inventory_type_radio"
              value={typeId ? typeId : ""}
              checked={isChecked}
              onChange={() => handleTypeSelect(typeId, typeText)}
            />
            <span>
              <div className="wantad-type-info">
                {adType !== BUY && Desc ? (
                  <>
                    <h2>{typeText}</h2>
                    <p>{Desc}</p>
                  </>
                ) : (
                  <h2 className="pb-0">{typeText}</h2>
                )}
              </div>
            </span>
          </label>
        </div>
      );
    });
  };

  return (
    <div className={!isEdit ? "center-content-sec mw-100" : ""}>
      <div className="wantad-type-wrap pb-24">
        <h6>Property Category</h6>
        <div className="row">
          {categories.map((cat) => (
            <div
              key={cat.CategoryId}
              className={
                !isEdit
                  ? "col-sm-12 col-lg-12 col-xl-12 col-xxl-6"
                  : "col-sm-12 col-lg-12 col-xl-12 col-xxl-12"
              }
            >
              <label className="radio-wrap mb-3">
                <input
                  type="radio"
                  name="inventory_category_radio"
                  value={cat.CategoryId}
                  checked={selectedCategory === cat.CategoryId}
                  onChange={() =>
                    handleCategorySelect(cat.CategoryId, cat.CategoryText)
                  }
                />
                <span>
                  <div className="wantad-type-info">
                    <h2 className="pb-0">{cat.CategoryText}</h2>
                  </div>
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>

      {selectedCategoryData && (
        <div className="wantad-type-wrap pb-24">
          <h6>Property Type</h6>
          <div className="row">{loadPropertyTypes()}</div>
        </div>
      )}
    </div>
  );
};

export default InventoryPropertyTypes;
